/**
 * Format the given date value to a formatted period.
 *
 * @param dateTime String
 * @returns String
 */
export const formatDateToPeriod = (dateTime) => {
    dateTime = new Date(dateTime)
    let month = dateTime.getMonth() + 1
    let formattedMonth = month < 10 ? '0' + month : month

    return dateTime.getFullYear() + '-' + (formattedMonth)
}
